import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { modeToFontColor } from 'ds/components/button/BasicButton';

// Button for non-standard icons. Use this button when you have an icon that uses stroke instead of fill.
export const CustomButton = styled(Button)`
  > svg path {
    fill: none !important;
    stroke: ${({ mode }) => modeToFontColor.default[mode]};
  }
  &:disabled {
    > svg path {
      stroke: ${({ mode }) => modeToFontColor.disabled[mode]};
    }
  }
  &:hover {
    > svg path {
      stroke: ${({ mode }) => modeToFontColor.hovered[mode]};
    }
  }
`;
